{
  "label": "label",
  "name": "name",
  "gamme": "gamme",
  "serialNumber": "Serial number",
  "firmwareVersion": "Firmware version",
  "status": "Status",
  "sector": "Sector",
  "certificate": "Certificate",
  "connectivity": "Connectivity",
  "applicationDate": "Application date",
  "date": "Date",
  "startDate": "Start date",
  "endDate": "End date",
  "id": "Id",
  "search": "Search"
}
